import { documenttypeActions } from "./documenttype-slice";
import { uiActions } from "../ui-slice";

export const Getdocumenttypes = (email, showNotification) => {
  return async (dispatch) => {
   if (showNotification !== undefined && showNotification === true) {
      dispatch(
        uiActions.showNotification({
          status: "pending",
          title: "Cargando información",
          message: "Se esta solicitando la información al servidor.",
        })
      );
    }
    const GetdocumenttypesInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/DocumentType/getall`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener la información solicitada");
      }
      const data = await response.json();
      return data;
    };

    try {
      const response = await GetdocumenttypesInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          documenttypeActions.setdocumenttypes({
            documenttypes: response.data.map((documenttype) => {
              return {
                ...documenttype,
                status: documenttype.status === true ? "Activo" : "Inactivo",
              };
            }),
          })
        );
       if (showNotification !== undefined && showNotification === true) {
          dispatch(
            uiActions.showNotification({
              status: "success",
              title: "Datos Cargados",
              message: response.result.message,
            })
          );
        }
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          documenttypeActions.setdocumenttypes({
            statues: [],
          })
        );
       if (showNotification !== undefined && showNotification === true) {
          dispatch(
            uiActions.showNotification({
              status: "warning",
              title: "Advertencia",
              message: response.result.message,
            })
          );
        }
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo obtener la información solicitada",
        })
      );
    }
  };
};
export const Getdocumenttype = (id, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Solicitando tipo de documento",
        message: "Solicitando tipo de documento al servidor.",
      })
    );
    const getdocumenttypeInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/DocumentType/getById`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            id: id,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener el tipo de documento");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await getdocumenttypeInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          documenttypeActions.setDocumenttype({
            documenttype: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Datos Cargados",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          documenttypeActions.setDocumenttype({
            documenttype: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo obtener el tipo de documento",
        })
      );
    }
  };
};
export const Updatedocumenttype = (documenttype, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Actualizando tipo de documento",
        message: "Solicitando Actualización del tipo de documento al servidor.",
      })
    );
    const updatedocumenttypeInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/DocumentType/update`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Id: documenttype.id,
            Name: documenttype.name,
            Code: documenttype.code,
            Description: documenttype.description,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo actualizar el tipo de documento");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await updatedocumenttypeInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          documenttypeActions.setDocumenttype({
            documenttype: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "tipo de documento Actualizado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          documenttypeActions.setDocumenttype({
            documenttype: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo actualizar el tipo de documento",
        })
      );
    }
  };
};
export const Createdocumenttype = (documenttype, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Creando tipo de documento",
        message: "Solicitando Creación del tipo de documento al servidor.",
      })
    );
    const createdocumenttypeInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/DocumentType/create`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Name: documenttype.name,
            Description: documenttype.description,
            Code: documenttype.code,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo crear el tipo de documento");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await createdocumenttypeInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          documenttypeActions.setDocumenttype({
            documenttype: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "tipo de documento Creado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          documenttypeActions.setDocumenttype({
            documenttype: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo crear el tipo de documento",
        })
      );
    }
  };
};
export const Activedocumenttype = (id, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Activando tipo de documento",
        message: "Solicitando activación del tipo de documento al servidor.",
      })
    );
    const activedocumenttypeInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/DocumentType/active`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            id: id,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo activar el tipo de documento");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await activedocumenttypeInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          documenttypeActions.setDocumenttype({
            documenttype: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "tipo de documento Activado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          documenttypeActions.setDocumenttype({
            documenttype: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo activar el tipo de documento",
        })
      );
    }
  };
};
export const Inactivedocumenttype = (id, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Inactivando tipo de documento",
        message: "Solicitando activación del tipo de documento al servidor.",
      })
    );
    const inactivedocumenttypeInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/DocumentType/inactive`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Id: id,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo inactivar el tipo de documento");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await inactivedocumenttypeInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          documenttypeActions.setDocumenttype({
            documenttype: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "tipo de documento Inactivado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          documenttypeActions.setDocumenttype({
            documenttype: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo inactivar el tipo de documento",
        })
      );
    }
  };
};
